import React from "react";
import calendar from "../../Assets/calendar.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const ThankYou = () => {
  return (
    <>
      <Helmet>
        <title>Thank You - 365LuxuryHomes</title>
        <meta
          name="description"
          content="We’ve received your submission. We’ll review your details and
          contact you shortly"
        />
        <link rel="canonical" href="http://localhost:5000/thank-you" />
      </Helmet>
      <div className="w-full h-dvh">
        <div className="flex items-center justify-center flex-col h-full">
          <img src={calendar} alt={""} className="lg:w-24 md:w-24 w-16 mb-4" />
          <h1 className="lg:text-6xl md:text-5xl text-4xl font-bold text-center text-[#74716d]">
            Thank You!
          </h1>
          <p className="text-center lg:mt-4 md:mt-3 mt-2 text-[#74716d]">
            We’ve received your submission. We’ll review your details and
            contact you shortly
          </p>
          <Link
            to={"/"}
            className="btn btn-sm bg-[#c3a963] text-white hover:text-[#c3a963] hover:bg-[#ffffff] hover:no-underline font-thin mt-4"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default ThankYou;
